<script>
import {
  ADVANCED_ACMF_AGGREGATE_DAYS_MIN,
  ADVANCED_ACMF_AGGREGATE_DAYS_MAX,
  ADVANCED_ACMF_AGGREGATE_REPORTS_MIN,
  ADVANCED_ACMF_AGGREGATE_REPORTS_MAX,
} from '@/utilities/appConsts'

import { isValidRecAction } from '@/utilities/customAlerts'
import { PLOTLY_CONSTS as PLYC } from '@/stores/consts'
import { mapActions } from 'vuex'

export default {
  methods: {
    logicComplexityOptions() {
      return [
        {
          id: 1,
          name: 'SIMPLE LOGIC',
          description:
            'Simple logic builder enables custom set threshold values for a single parameter.',
        },
        {
          id: 2,
          name: 'ADVANCED LOGIC',
          description:
            'Advanced logic builder uses an open script field that enable you to build unique logic strings with multiple functions and parameter selections.',
        },
      ]
    },
    calculateMinRangeInvalid(thresholds) {
      if (thresholds.minRange === undefined || thresholds.minRange === null) {
        return false
      }
      if (isNaN(thresholds.minRange)) {
        return true
      } else {
        if (
          thresholds.minRange === thresholds.lowWarning ||
          thresholds.minRange === thresholds.maxRange ||
          thresholds.minRange === thresholds.highWarning ||
          thresholds.minRange === thresholds.lowCaution ||
          thresholds.minRange === thresholds.highCaution
        ) {
          return true
        }
        // min range must be less than all the other thresholds
        if (
          (thresholds.minRange || thresholds.minRange === 0) &&
          ((thresholds.maxRange && thresholds.minRange > thresholds.maxRange) ||
            (thresholds.highWarning &&
              thresholds.minRange > thresholds.highWarning) ||
            (thresholds.highCaution &&
              thresholds.minRange > thresholds.highCaution) ||
            (thresholds.lowCaution &&
              thresholds.minRange > thresholds.lowCaution) ||
            (thresholds.lowWarning &&
              thresholds.minRange > thresholds.lowWarning))
        ) {
          return true
        } else {
          return false
        }
      }
    },
    calculateMaxRangeInvalid(thresholds) {
      if (thresholds.maxRange === undefined || thresholds.maxRange === null) {
        return false
      }
      if (isNaN(thresholds.maxRange)) {
        return true
      } else {
        if (
          thresholds.maxRange === thresholds.lowWarning ||
          thresholds.maxRange === thresholds.minRange ||
          thresholds.maxRange === thresholds.highWarning ||
          thresholds.maxRange === thresholds.lowCaution ||
          thresholds.maxRange === thresholds.highCaution
        ) {
          return true
        }
        // max range must be greater than all the other thresholds
        if (
          (thresholds.maxRange || thresholds.maxRange === 0) &&
          ((thresholds.minRange && thresholds.maxRange < thresholds.minRange) ||
            (thresholds.highWarning &&
              thresholds.maxRange < thresholds.highWarning) ||
            (thresholds.highCaution &&
              thresholds.maxRange < thresholds.highCaution) ||
            (thresholds.lowCaution &&
              thresholds.maxRange < thresholds.lowCaution) ||
            (thresholds.lowWarning &&
              thresholds.maxRange < thresholds.lowWarning))
        ) {
          return true
        } else {
          return false
        }
      }
    },
    tryParseIntToStringIfNan(value) {
      if (isNaN(value)) {
        return value
      }

      return Number(value)
    },
    calculateLowWarningInvalid(thresholds) {
      if (
        thresholds.lowWarning === undefined ||
        thresholds.lowWarning === null
      ) {
        return false
      }
      if (thresholds.minRange === thresholds.lowWarning) {
        return true
      }
      if (
        thresholds.lowWarning === thresholds.maxRange ||
        thresholds.lowWarning === thresholds.minRange ||
        thresholds.lowWarning === thresholds.highWarning ||
        thresholds.lowWarning === thresholds.lowCaution ||
        thresholds.lowWarning === thresholds.highCaution
      ) {
        return true
      }
      // low caution must be less than low caution, high caution, high warning and high range and greater
      if (
        ((thresholds.maxRange || thresholds.maxRange === 0) &&
          thresholds.lowWarning > thresholds.maxRange) ||
        (thresholds.highWarning &&
          thresholds.lowWarning > thresholds.highWarning) ||
        (thresholds.highCaution &&
          thresholds.lowWarning > thresholds.highCaution) ||
        (thresholds.lowCaution &&
          thresholds.lowWarning > thresholds.lowCaution) ||
        ((thresholds.minRange || thresholds.minRange === 0) &&
          thresholds.lowWarning < thresholds.minRange)
      ) {
        return true
      } else {
        return false
      }
    },
    calculateLowCautionInvalid(thresholds) {
      if (
        thresholds.lowCaution === undefined ||
        thresholds.lowCaution === null
      ) {
        return false
      }
      if (
        thresholds.lowCaution === thresholds.maxRange ||
        thresholds.lowCaution === thresholds.minRange ||
        thresholds.lowCaution === thresholds.highWarning ||
        thresholds.lowCaution === thresholds.lowWarning ||
        thresholds.lowCaution === thresholds.highCaution
      ) {
        return true
      }
      // low caution must be less than high warning, high caution and high range and greater
      // than any of the other thresholds
      if (
        ((thresholds.maxRange || thresholds.maxRange === 0) &&
          thresholds.lowCaution > thresholds.maxRange) ||
        (thresholds.highWarning &&
          thresholds.lowCaution > thresholds.highWarning) ||
        (thresholds.highCaution &&
          thresholds.lowCaution > thresholds.highCaution) ||
        (thresholds.lowWarning &&
          thresholds.lowCaution < thresholds.lowWarning) ||
        ((thresholds.minRange || thresholds.minRange === 0) &&
          thresholds.lowCaution < thresholds.minRange)
      ) {
        return true
      } else {
        return false
      }
    },
    calculateHighCautionInvalid(thresholds) {
      if (
        thresholds.highCaution === undefined ||
        thresholds.highCaution === null
      ) {
        return false
      }
      if (
        thresholds.highCaution === thresholds.maxRange ||
        thresholds.highCaution === thresholds.minRange ||
        thresholds.highCaution === thresholds.highWarning ||
        thresholds.highCaution === thresholds.lowWarning ||
        thresholds.highCaution === thresholds.lowCaution
      ) {
        return true
      }
      // high caution must be less than high warning and high range and greater
      // than any of the other thresholds
      if (
        ((thresholds.maxRange || thresholds.maxRange === 0) &&
          thresholds.highCaution > thresholds.maxRange) ||
        (thresholds.highWarning &&
          thresholds.highCaution > thresholds.highWarning) ||
        (thresholds.lowCaution &&
          thresholds.highCaution < thresholds.lowCaution) ||
        (thresholds.lowWarning &&
          thresholds.highCaution < thresholds.lowWarning) ||
        ((thresholds.minRange || thresholds.minRange === 0) &&
          thresholds.highCaution < thresholds.minRange)
      ) {
        return true
      } else {
        return false
      }
    },
    calculateHighWarningInvalid(thresholds) {
      if (
        thresholds.highWarning === undefined ||
        thresholds.highWarning === null
      ) {
        return false
      }
      if (
        thresholds.highWarning === thresholds.maxRange ||
        thresholds.highWarning === thresholds.minRange ||
        thresholds.highWarning === thresholds.highCaution ||
        thresholds.highWarning === thresholds.lowWarning ||
        thresholds.highWarning === thresholds.lowCaution
      ) {
        return true
      }
      // high warning must be less than high range and greater
      // than any of the other thresholds
      if (
        ((thresholds.maxRange || thresholds.maxRange === 0) &&
          thresholds.highWarning > thresholds.maxRange) ||
        (thresholds.highCaution &&
          thresholds.highWarning < thresholds.highCaution) ||
        (thresholds.lowCaution &&
          thresholds.highWarning < thresholds.lowCaution) ||
        (thresholds.lowWarning &&
          thresholds.highWarning < thresholds.lowWarning) ||
        ((thresholds.minRange || thresholds.minRange === 0) &&
          thresholds.highWarning < thresholds.minRange)
      ) {
        return true
      } else {
        return false
      }
    },
    calculateActivateEnabled(alertData) {
      // activate is enabled when:
      // persistence is set correctly
      const isPersistenceCorrect = this.getIsPersistenceCorrect(alertData)

      const tailsSet = alertData?.tails && alertData.tails.length > 0

      // at least one threshold value is set and checked AND valid
      const thresholds = {
        lowWarning: alertData?.lowWarning,
        lowCaution: alertData?.lowCaution,
        highCaution: alertData?.highCaution,
        highWarning: alertData?.highWarning,
        minRange: alertData?.minRange,
        maxRange: alertData?.maxRange,
      }

      const anyInvalidThresholdsChecked =
        (this.calculateLowWarningInvalid(thresholds) &&
          alertData.isLowWarningEnabled) ||
        (this.calculateLowCautionInvalid(thresholds) &&
          alertData.isLowCautionEnabled) ||
        (this.calculateHighCautionInvalid(thresholds) &&
          alertData.isHighCautionEnabled) ||
        (this.calculateHighWarningInvalid(thresholds) &&
          alertData.isHighWarningEnabled)

      const atLeastOneValidThresholdChecked =
        (!this.calculateLowWarningInvalid(thresholds) &&
          alertData.isLowWarningEnabled) ||
        (!this.calculateLowCautionInvalid(thresholds) &&
          alertData.isLowCautionEnabled) ||
        (!this.calculateHighCautionInvalid(thresholds) &&
          alertData.isHighCautionEnabled) ||
        (!this.calculateHighWarningInvalid(thresholds) &&
          alertData.isHighWarningEnabled)

      if (alertData.alertType === 'fullflight') {
        const flightPhaseSet =
          alertData?.flightPhase && alertData.flightPhase.length > 0
        return (
          isPersistenceCorrect &&
          tailsSet &&
          flightPhaseSet &&
          !anyInvalidThresholdsChecked &&
          atLeastOneValidThresholdChecked
        )
      } else {
        return (
          isPersistenceCorrect &&
          tailsSet &&
          !anyInvalidThresholdsChecked &&
          atLeastOneValidThresholdChecked
        )
      }
    },
    calculateActivateEnabledAdvanced(alertData) {
      // activate is enabled when:
      // persistence is set correctly or aggegate-days is greater than 1 or aggegate-reports is greater than 1
      const isPersistenceSelected =
        !alertData?.configurationType?.includes('aggregate')
      const isConfigurationValid = isPersistenceSelected
        ? this.getIsPersistenceCorrect(alertData)
        : this.getIsAggregateCorrect(alertData)
      const tailsSet = alertData?.tails && alertData.tails.length > 0
      const isLogicValid = alertData?.validLogic
      const isSeverityLevelPresent =
        alertData?.severityLevel && alertData?.severityLevel.length > 0

      if (
        alertData.alertType === 'advanced-fullflight' ||
        alertData.alertType === 'advanced-acmf'
      ) {
        const ataChaptersSet = alertData?.ataChapters?.length > 0
        const recActionSet = isValidRecAction(alertData?.recAction)
        return (
          isConfigurationValid &&
          tailsSet &&
          ataChaptersSet &&
          recActionSet &&
          isLogicValid &&
          isSeverityLevelPresent
        )
      }

      if (alertData.alertType === 'fullflight') {
        const flightPhaseSet =
          alertData?.flightPhase && alertData.flightPhase.length > 0
        return isConfigurationValid && tailsSet && flightPhaseSet
      } else {
        return (
          isConfigurationValid &&
          tailsSet &&
          isSeverityLevelPresent &&
          isLogicValid
        )
      }
    },
    getIsAggregateCorrect(alertData) {
      return alertData?.configurationType?.includes('Days')
        ? alertData?.aggregateDays
          ? Number.isInteger(alertData?.aggregateDays) &&
            alertData?.aggregateDays >= ADVANCED_ACMF_AGGREGATE_DAYS_MIN &&
            alertData?.aggregateDays <= ADVANCED_ACMF_AGGREGATE_DAYS_MAX
          : false
        : alertData?.aggregateReports
        ? Number.isInteger(alertData?.aggregateReports) &&
          alertData?.aggregateReports >= ADVANCED_ACMF_AGGREGATE_REPORTS_MIN &&
          alertData?.aggregateReports <= ADVANCED_ACMF_AGGREGATE_REPORTS_MAX
        : false
    },
    getIsPersistenceCorrect(alertData) {
      return (
        alertData?.persistenceFrom !== null &&
        alertData?.persistenceTo !== null &&
        alertData?.persistenceFrom <= alertData?.persistenceTo &&
        alertData?.persistenceTo >= alertData?.persistenceFrom
      )
    },
    ...mapActions(PLYC.NAMESPACE, [PLYC.GET_PLOTLY_TOKEN]),
    async getPlotly(alertData) {
      var airlineIcaoCode = this.mappedUserAirlines.filter(
        x => x.airlineId === this.airlineId,
      )[0].icaoCode
      var plotlyData = await this[PLYC.GET_PLOTLY_TOKEN]({
        data: {
          lookbackFunctionGuid: alertData.guid,
          runId: alertData.runId,
          airlineName: this.airline,
          airlineIcaoCode: airlineIcaoCode,
          platform: this.platform,
        },
        type: 'CustomAlertLookback',
      })
      return plotlyData
    },
  },
}
</script>
